import styled from 'styled-components'
import { Link } from '@navent-jobs/ui-kit/components/link'
import { Col } from '@navent-jobs/ui-kit/components/grid'
import ReadMore from '@navent-jobs/ui-kit/components/ReadMore'

const styledCardDefault = styled('div')`
  background: ${({ theme }) => theme.colors.grey0};
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 16px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-bottom: 20px;
  }
`
export const ReviewPadder = styled('div')`
  margin-bottom: 16px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-bottom: 20px;
  }
`

export const EmpresaDetail = styled('div')`
  display: flex;
  flex-direction: column;
`

export const CustomCol = styled(Col)`
  margin-top: 24px;
`

export const NameCompany = styled('div')`
  margin-bottom: 16px;
`

export const DetalleLookAndFeel = styled(styledCardDefault)``

export const ButtonPerfilEmpresa = styled(Link)`
  width: 100%;
  padding: 13px;
  margin-bottom: 16px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-bottom: 24px;
  }
`

export const DescripcionEmpresa = styled(styledCardDefault)``

export const VideoWrapper = styled(styledCardDefault)`
  margin-bottom: 0px;
`

export const RatioResponsive = styled('div')`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
`

export const Video = styled('iframe')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Separador = styled('div')`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grey24};
  margin: 24px 0px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin: 32px 0px;
  }
`

export const ReadMoreCustom = styled(ReadMore)``

export const Container = styled.div`
  margin-bottom: 14px;
`

export const InformationContainer = styled.div`
  ${({ sacarUltimoMargen }) =>
    sacarUltimoMargen
      ? `
    div:last-child {
      margin-bottom: 0px;
    }
  `
      : ''}
`
